import React, {useMemo } from 'react'
import { map } from 'lodash'
import { Wrapper, Status  } from "@googlemaps/react-wrapper"

import MapComponent from './MapComponent'

export default ({clinics, activeClinic}) => {
  const googleMapApikey = 'AIzaSyDWN-BbqlsxzZBrMG_WOVmA42NGm8kJqp4'

  const containerStyle = {
    width: '100%',
    height: '100%'
  };

  const render = (status) => {
    switch (status) {
      case Status.LOADING:
        return <div>loading</div>;
      case Status.FAILURE:
        return <div>error</div>;
      case Status.SUCCESS:
        return <MapComponent clinics={clinics} activeClinic={activeClinic} zoom={13}>
         
        </MapComponent>
    }
  }
 
  return (
    <div className="w-full h-[500px] mb-8">
       <Wrapper apiKey={googleMapApikey} render={render}>
        
       </Wrapper>
    </div>
  )
}